module.exports = __webpack_public_path__ + "static/media/gsoc.5a17fdc1.jpg";